// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YourWinBack_container {
  width: 95%;
  background-color: var(--white);
  padding: 3rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
}
.YourWinBack_container .btn_container {
  display: flex;
  /* flex-direction: column; */
  justify-content: space-evenly;
  align-items: center;
  margin: 5rem 0;
}
.YourWinBack_container .btn_container button {
  border: none;
}
.YourWinBack_container .btn_container button:focus {
  box-shadow: #1fdf49 0 4px 15px -5px;
}
.YourWinBack_container .positiveShift_container {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: center;
  padding: 2rem 1rem;
  border-radius: 1rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.YourWinBack_container .uniqueCustomers_container h1 {
  color: black !important;
}
.YourWinBack_container .section_div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
}
.YourWinBack_container .section_div .section_nums {
  /* padding: 0.1rem 1rem;
  background-color: black;
  border-radius: 0.5rem;
  color: #1fdf49; */
  color: black !important;
  font-size: 3.5rem;
}
.ant-spin-dot-item {
  background-color: white;
}
.ant-modal {
  overflow: hidden !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/YourWinBack.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE;;;mBAGiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".YourWinBack_container {\n  width: 95%;\n  background-color: var(--white);\n  padding: 3rem;\n  border-radius: 1rem;\n  margin-bottom: 2rem;\n}\n.YourWinBack_container .btn_container {\n  display: flex;\n  /* flex-direction: column; */\n  justify-content: space-evenly;\n  align-items: center;\n  margin: 5rem 0;\n}\n.YourWinBack_container .btn_container button {\n  border: none;\n}\n.YourWinBack_container .btn_container button:focus {\n  box-shadow: #1fdf49 0 4px 15px -5px;\n}\n.YourWinBack_container .positiveShift_container {\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n  text-align: center;\n  padding: 2rem 1rem;\n  border-radius: 1rem;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n.YourWinBack_container .uniqueCustomers_container h1 {\n  color: black !important;\n}\n.YourWinBack_container .section_div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  cursor: pointer;\n}\n.YourWinBack_container .section_div .section_nums {\n  /* padding: 0.1rem 1rem;\n  background-color: black;\n  border-radius: 0.5rem;\n  color: #1fdf49; */\n  color: black !important;\n  font-size: 3.5rem;\n}\n.ant-spin-dot-item {\n  background-color: white;\n}\n.ant-modal {\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
